module.exports = function getResource(label, vars = []) {
    const resources = {
        moreDeliveryOptions: 'D’autres options de livraison',
        noGiftWrap: 'Pas d’emballage-cadeau',
        addGiftOptions: '*Ajouter des options d’emballage-cadeau* (facultatif)',
        optionalCharactersMax: `Facultatif (maximum de ${vars[0]} caractères)`,
        noSpecialCharsAllowed: 'Les caractères spéciaux ne sont pas autorisés.',
        giftMessage: 'Message du cadeau',
        giftOptions: 'Options cadeaux',
        giftWrap: 'Emballage-cadeau',
        selectedDeliveryMethodMessage: `Le mode de livraison choisi n’est pas valable avec le code promotionnel ${vars[0]} : ${vars[1]}. Vous devez sélectionner ${vars[2]} pour qu’il soit valide. Si vous continuez, la promotion ${vars[3]} sera retirée.`,
        confirmation: 'Confirmation',
        continueButton: 'Continuer',
        freeShipSignIn: `${vars[0]} or ${vars[1]} to enjoy ${vars[2]}.`,
        signIn: 'Sign in',
        createAccount: 'create an account',
        freeStandardShipping: 'FREE standard shipping'
    };

    return resources[label];
};
